import React from 'react';
import { Global, css } from '@emotion/react';

export function AuCardsTheme() {
  return (
    <Global
      styles={theme => css`
        label {
          color: ${theme.colors.indigo};
        }

        form input {
          color: ${theme.colors.indigo};
        }

        p {
          color: ${theme.colors.indigo};
        }
      `}
    />
  );
}
